module.exports = "/assets/data/85c25d420b770052f67ebaa66b0fffbb-EC4N.data.json";